import { useState } from "react";
import useKlydoFeedStats from "../../../components/hooks/useKlydoFeedStats";
import DSCard from "views/system-design/DSCard";
import DSCardContent from "views/system-design/DSCardContent";
import DSBox from "views/system-design/DSBox";
import DSStack from "views/system-design/DSStack";
import DSTypography from "views/system-design/DSTypography";
import DSSelect from "views/system-design/DSSelect";
import DSMenuItem from "views/system-design/DSMenuItem";
import DSSecondaryButton from "views/system-design/DSSecondaryButton";
import DSCircularProgress from "views/system-design/DSCircularProgress";

function KlydoFeedAnalyticsCard() {
  const [days, setDays] = useState<number>(30);
  const [enabled, setEnabled] = useState(false);
  const { data, isLoading, refetch } = useKlydoFeedStats(days, enabled);

  const handleLoad = () => {
    if (enabled) {
      refetch();
    } else {
      setEnabled(true);
    }
  };

  return (
    <DSCard sx={{ height: "100%" }}>
      <DSBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          pt: 2,
          gap: 1,
        }}
      >
        <DSTypography variant="h6">Klydo Feed Analytics</DSTypography>
        <DSStack direction="row" alignItems="center" spacing={1}>
          <DSTypography variant="caption" sx={{ color: "text.secondary" }}>
            Last
          </DSTypography>
          <DSSelect<number>
            size="small"
            value={days}
            onChange={(e) => {
              setDays(Number(e.target.value));
              setEnabled(false);
            }}
            sx={{ fontSize: 12 }}
          >
            {[7, 14, 30, 60, 90].map((d) => (
              <DSMenuItem key={d} value={d}>
                {d}d
              </DSMenuItem>
            ))}
          </DSSelect>
          <DSSecondaryButton
            size="small"
            onClick={handleLoad}
            disabled={isLoading}
          >
            {isLoading ? (
              <DSCircularProgress size={20} />
            ) : data ? (
              "Refresh"
            ) : (
              "Load"
            )}
          </DSSecondaryButton>
        </DSStack>
      </DSBox>
      <DSCardContent>
        {isLoading ? (
          <DSBox sx={{ textAlign: "center", p: "20px" }}>
            <DSCircularProgress />
          </DSBox>
        ) : data ? (
          <DSBox
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              textAlign: "center",
              gap: 1,
            }}
          >
            <DSBox>
              <DSTypography sx={{ fontSize: 28, fontWeight: "bold" }}>
                {data.klydosPublished.toLocaleString()}
              </DSTypography>
              <DSTypography sx={{ fontSize: 12, color: "text.secondary" }}>
                Published
              </DSTypography>
            </DSBox>
            <DSBox>
              <DSTypography sx={{ fontSize: 28, fontWeight: "bold" }}>
                {data.klydosReachedFeed.toLocaleString()}
              </DSTypography>
              <DSTypography sx={{ fontSize: 12, color: "text.secondary" }}>
                Reached Feed ({data.reachedFeedPercentage}%)
              </DSTypography>
            </DSBox>
            <DSBox>
              <DSTypography sx={{ fontSize: 28, fontWeight: "bold" }}>
                {data.avgDaysToFeed != null ? `${data.avgDaysToFeed}d` : "—"}
              </DSTypography>
              <DSTypography sx={{ fontSize: 12, color: "text.secondary" }}>
                Avg Days to Feed
              </DSTypography>
            </DSBox>
          </DSBox>
        ) : (
          <DSBox
            sx={{ textAlign: "center", p: "20px", color: "text.secondary" }}
          >
            Click Load to fetch data
          </DSBox>
        )}
      </DSCardContent>
    </DSCard>
  );
}

export default KlydoFeedAnalyticsCard;
